module.exports = __webpack_public_path__ + "static/media/superdry2.b153c1b9.jpg";